import { useState } from 'react';
import { useCustom } from '@refinedev/core';
import { Card, Segmented } from 'antd';
import { Area } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { MonetizationTrendDailyOut } from '@/api/generated/schemas';
import { cleanFilters, type MonetizationStatsFilters } from './filters';

const PERIODS = [
  { label: '7 dni', value: 7 },
  { label: '30 dni', value: 30 },
  { label: '90 dni', value: 90 },
];

const SERIES_LABELS = {
  new_accounts: 'Nowi',
  renewals: 'Odnowienia',
  churned_accounts: 'Rezygnacje',
} as const;

type Props = { filters: MonetizationStatsFilters };

export const MonetizationTrendChart = ({ filters }: Props) => {
  const [days, setDays] = useState(30);

  const { query } = useCustom<MonetizationTrendDailyOut[]>({
    url: 'monetization/subscriptions/stats/trend_daily',
    method: 'get',
    config: { query: { days, ...cleanFilters(filters) } },
  });

  const rows = query.data?.data ?? [];
  const chartData = rows.flatMap((row) =>
    (Object.keys(SERIES_LABELS) as (keyof typeof SERIES_LABELS)[]).map(
      (key) => ({
        date: row.date,
        type: SERIES_LABELS[key],
        count: row[key],
      })
    )
  );

  return (
    <Card
      title="Trend subskrypcji"
      extra={
        <Segmented
          options={PERIODS.map((p) => ({ label: p.label, value: p.value }))}
          value={days}
          onChange={(v) => setDays(v as number)}
        />
      }
      loading={query.isLoading}
    >
      <Area
        data={chartData}
        xField="date"
        yField="count"
        colorField="type"
        height={260}
        legend={BOTTOM_LEGEND}
      />
    </Card>
  );
};
